import { useEffect, useState } from "react";

export const useAsyncLoadImage = (src?: string, opImage = false) => {
  const [result, setResult] = useState<string>();

  useEffect(() => {
    setResult(undefined);
    const image = new Image();
    if (!src) return;
    image.src = src;
    if (typeof window === "undefined") {
      setResult(image.src);
    } else {
      image.onload = () => {
        setResult(image.src);
      };
    }
  }, [opImage, src]);
  return result;
};
